import styled from "styled-components";

export const DocumentosContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const DocumentoItem = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 16px;
  background-color: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background-color: #f0f0f0;
  }
`;

export const ArchivoInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: left;
`;

export const ArchivoNombre = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 2px;
`;

export const ArchivoTamaño = styled.span`
  font-size: 12px;
  color: #666;
`;

export const AccionesContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const AccionIcono = styled.span`
  font-size: 20px;
  cursor: pointer;
  transition: color 0.2s ease;
  padding: 4px;
  border-radius: 4px;

  &:hover {
    background-color: ${props => props.tipo === 'ver' ? '#f0f8ff' : '#fff5f5'};
  }
`;

export const VerIcono = styled(AccionIcono)`
  color: ${props => props.colorPrincipal || "#007bff"};

  &:hover {
    color: #0056b3;
  }
`;

export const EliminarIcono = styled(AccionIcono)`
  color: ${props => props.colorEliminar || "#dc3545"};

  &:hover {
    color: #c82333;
  }
`;

export const SeccionContainer = styled.div`
  width: ${props => props.width || "100%"};
  margin-bottom: ${props => props.marginBottom || "20px"};
  display: ${props => props.display || "flex"};
  flex-direction: ${props => props.flexDirection || "column"};
  align-items: ${props => props.alignItems || "flex-start"};
  justify-content: ${props => props.justifyContent || "flex-start"};
`;

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001;
  padding: 20px;
`;

export const ModalContenido = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 0;
  max-width: 90vw;
  max-height: 90vh;
  width: ${props => props.tipoArchivo === 'pdf' ? '50vw' : 'auto'};
  min-width: ${props => props.tipoArchivo === 'pdf' ? '800px' : 'auto'};
  height: auto;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
  background-color: #f8f9fa;
`;

export const ModalTitulo = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 50px);
`;

export const ModalCerrarBtn = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #666;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;

  &:hover {
    background-color: #e9ecef;
    color: #333;
  }
`;

export const ModalDocumentoContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: #f8f9fa;
  min-height: 400px;
`;

export const ModalImagen = styled.img`
  max-width: 100%;
  max-height: 70vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease;
  cursor: zoom-in;

  &:hover {
    transform: scale(1.02);
  }
`;

export const ModalPdfContainer = styled.div`
  width: 100%;
  height: 75vh;
  min-height: 500px;
  border: none;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

export const ModalPdfIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

export const ModalMensaje = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  text-align: center;
  color: #666;
`;

export const ModalIcono = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
`;

export const ModalTexto = styled.p`
  font-size: 16px;
  margin: 0;
  line-height: 1.5;
`;

export const ModalDescargaBtn = styled.button`
  background-color: ${props => props.colorPrincipal || "#007bff"};
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 16px;

  &:hover {
    background-color: ${props => props.colorPrincipal ? props.colorPrincipal : "#0056b3"};
    transform: translateY(-1px);
  }
`;
